import React from 'react';
import { Navigate, Route } from 'react-router';

import ErrorPage from 'app/components/ErrorPage';
import MainLayout from 'app/components/layouts/MainLayout';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import appsRoutes from './apps';

const basePath = '/v2/info';

export default (
  <Route path={basePath}>
    <Route index element={<Navigate replace to={`${basePath}/apps`} />} />
    {appsRoutes}
    <Route
      path="*"
      element={
        <MainLayout>
          <ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />
        </MainLayout>
      }
    />
  </Route>
);
